module.exports = __webpack_public_path__ + "img/deleteButton.711ceac7.png";